export function getConfluenceURL(): string {
  return `https://corpinfollc.atlassian.net/wiki/spaces`;
}

export function getConfluenceSpaceURL(jiraKey: string): string {
  return `${getConfluenceURL()}/${jiraKey}`;
}
